export function initialsFor(employer: string): string {
  const tokens = employer.trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return '—';
  if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase();
  return (tokens[0][0] + tokens[1][0]).toUpperCase();
}

export function formatSalary(min: number, max: number, locale: 'en' | 'fr'): string {
  const nf = new Intl.NumberFormat(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 0,
  });
  return `${nf.format(min)}–${nf.format(max)}`;
}

export function formatStartDate(
  startDate: string | null,
  locale: 'en' | 'fr',
  t: (key: string) => string,
  keyPrefix: string,
): string {
  // Same malformed-input guard as msca-shell's formatEffectiveDate: a shape
  // check plus a NaN check, so a bad BFF value falls back to the TBD wording
  // instead of Intl.DateTimeFormat rendering the literal string "Invalid Date".
  if (!startDate || !/^\d{4}-\d{2}-\d{2}$/.test(startDate)) {
    return t(`${keyPrefix}.startDateTBD`);
  }
  // Append T00:00:00 to parse as local time, not UTC midnight (which drifts
  // one day back on any machine behind UTC).
  const date = new Date(`${startDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return t(`${keyPrefix}.startDateTBD`);
  }
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
}

export function formatPostedDate(
  postedDaysAgo: number,
  t: (key: string, vars?: Record<string, unknown>) => string,
  keyPrefix: string,
): string {
  if (postedDaysAgo === 0) return t(`${keyPrefix}.postedToday`);
  if (postedDaysAgo === 1) return t(`${keyPrefix}.postedOneDayAgo`);
  return t(`${keyPrefix}.postedDaysAgo`, { count: postedDaysAgo });
}
